import React from 'react'
import {
  AccountDetailsUserInfo,
  AccountDetailsRolesRadioInput,
  AccountDetailsCheckboxInput,
} from 'components'

const AccountDetailsFormikController = props => {
  const { control, ...rest } = props
  switch (control) {
    case 'userDetails':
      return <AccountDetailsUserInfo {...rest} />
    case 'radio':
      return <AccountDetailsRolesRadioInput {...rest} />
    case 'checkbox':
      return <AccountDetailsCheckboxInput {...rest} />

    default:
      return null
  }
}
export default AccountDetailsFormikController
